import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { handleSpecialCharacters } from '../../Utils/Helper';


const styles = ({
  titleHead: {
    padding: '18px 0px'
  },
  divToolbar: {
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  searchArea: {
    display: 'flex',
    alignItems: 'inherit'
  },
  formControl: {
    minWidth: '150px'
  },
  searchField: {
    width: '240px',
    marginTop: '16px'
  },
  searchIconMargin: {
    marginRight: '4px'
  }
});

class AdminToolbar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchBy: ''
    }
  }

  handleSearch = event => {
    this.setState({ searchBy: handleSpecialCharacters(event.target.value) });
    this.props.reloadTableBySearch(handleSpecialCharacters(event.target.value));
  };


  render() {
    const { classes } = this.props;

    return (
      <div className={classes.divToolbar}>
        <Typography className={classes.titleHead} variant='title' id='tableTitle'>
          {this.props.titleTableList}
        </Typography>

        <div className={classes.searchArea}>
          <FormControl className={classes.formControl}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item>
                <TextField
                  id='search'
                  label=''
                  placeholder='Pesquisar'
                  type='search'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' className={classes.searchIconMargin}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  className={classes.searchField}
                  value={this.state.searchBy}
                  onChange={this.handleSearch}
                />
              </Grid>
            </Grid>
          </FormControl>
        </div>

      </div>
    );
  }

};

AdminToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func.isRequired
};

export default withStyles(styles)(AdminToolbar);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminToolbar.js